/**
 * The screens a proposal ROUTE shows instead of the form when it must not hand the
 * form over: "you may not", "we could not find out", "this is no longer editable",
 * and the wait while we are still finding out.
 *
 * CZNA-602 — extracted from ProposalCreate, where CZNA-591 first wrote it. It is
 * shared rather than copied for the reason this ticket exists: the same defect was
 * fixed on the create route and left standing on the edit route, because the gate
 * lived in one file. A second copy would have re-created that split on the day the
 * copy stopped matching.
 *
 * The routes keep their own PREDICATES and their own COPY — what belongs to a
 * proposal's state and the caller's roles is route knowledge. Only the chrome and
 * the layout traps below are shared.
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Paneset, Pane, Layout, Headline, Button, Loading } from '@folio/stripes/components';
/**
 * A full-pane container where the form would have been.
 *
 * A root Paneset, like every other pane-rendering route here (Dashboard,
 * CorpusQuality, RecordForm's standalone mount). A bare Pane has no layout container
 * and would not position itself — and jest cannot catch that, because the components
 * mock renders Pane and Layout as plain divs.
 */
var ProposalGatePane = function (_a) {
    var onClose = _a.onClose, children = _a.children;
    return (React.createElement(Paneset, { isRoot: true },
        React.createElement(Pane, { defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-czna-authorities.proposals.title" }), dismissible: onClose ? true : undefined, onClose: onClose },
            React.createElement(Layout, { className: "display-flex flex-direction-column centerContent" },
                React.createElement(Layout, { className: "padding-all-gutter" }, children)))));
};
/** Explains what the user is missing, or why the form cannot be opened, with a way back. */
export var ProposalGateMessage = function (_a) {
    var testId = _a.testId, heading = _a.heading, body = _a.body, backLabelId = _a.backLabelId, onClose = _a.onClose;
    return (React.createElement(ProposalGatePane, { onClose: onClose },
        React.createElement("div", { "data-testid": testId }),
        React.createElement(Headline, { size: "medium", margin: "none" }, heading),
        React.createElement("p", { style: { color: '#666', marginTop: '8px' } }, body),
        React.createElement(Button, { buttonStyle: "primary", style: { marginTop: '16px' }, onClick: onClose },
            React.createElement(FormattedMessage, { id: backLabelId }))));
};
/**
 * Shown while the answer is still being fetched.
 *
 * The permission context arrives asynchronously and reads as "no roles" until it
 * does; rendering a denial during that window would flash "nemáte oprávnění" at every
 * legitimate cataloguer on every mount.
 */
export var ProposalGateLoading = function () { return (React.createElement(ProposalGatePane, null,
    React.createElement(Loading, { size: "xlarge" }))); };
